import React from "react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { cx } from "components/Graphs/utils";

export interface DetailBreadcrumbItem {
  label: React.ReactNode;
  onNavigate?: () => void;
}

interface DetailBreadcrumbProps {
  items: DetailBreadcrumbItem[];
  className?: string;
}

const breadcrumbItemClassName =
  "text-sm text-secondary hover:text-gray-300 cursor-pointer";

export const DetailBreadcrumb: React.FC<DetailBreadcrumbProps> = ({
  items,
  className,
}) => (
  <nav aria-label="Breadcrumb" className={cx("flex", className)}>
    <ol className="flex items-end space-x-4">
      {items.map(({ label, onNavigate }, index) => {
        const hasSeparator = index > 0;

        return (
          <li key={index}>
            <div className={cx(hasSeparator && "flex items-center")}>
              {hasSeparator && (
                <ChevronRightIcon
                  className="flex-shrink-0 h-3 w-3 text-secondary"
                  aria-hidden="true"
                />
              )}
              <a
                onClick={onNavigate}
                aria-current={index === items.length - 1 ? "page" : undefined}
                className={cx(breadcrumbItemClassName, hasSeparator && "ml-4")}
              >
                {label}
              </a>
            </div>
          </li>
        );
      })}
    </ol>
  </nav>
);
